
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePassword } from '@/contexts';

interface RouteGuardProps {
  children: React.ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const location = useLocation();
  const { hasPassword } = usePassword();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuthentication = () => {
      if (!hasPassword) {
        setIsAuthenticated(true);
        setIsChecking(false);
        return;
      }

      // Check if there's a valid auth session
      const authSession = localStorage.getItem('nalc_auth_session');
      if (authSession) {
        try {
          const { expires } = JSON.parse(authSession);
          if (new Date(expires) > new Date()) {
            setIsAuthenticated(true);
          }
        } catch (e) {
          // Invalid session format
        }
      }
      
      setIsChecking(false);
    };

    checkAuthentication();
  }, [hasPassword, location.pathname]);

  if (isChecking) {
    return null;
  }

  // We're not showing the LockScreen here anymore since it's handled by AppLayout
  // This prevents the duplicate password screen
  return <>{children}</>;
};

export default RouteGuard;
